import { Button, ConfigProvider } from "antd";
import type { ButtonProps } from "antd";
import { withClickTracking } from "hooks/useAnalytics";
import { useAntTheme } from "hooks/useAntTheme";

export const ShadowButton = ({ children, ...props }: ButtonProps) => {
  const { theme } = useAntTheme();

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultShadow: theme.boxShadow,
            primaryShadow: theme.boxShadow,
            dangerShadow: theme.boxShadow,
            // force no border for non primary buttons
            // better to do it here than in styles to support on hover border
            defaultBorderColor: "transparent",
          },
        },
      }}
    >
      <Button {...props}>{children}</Button>
    </ConfigProvider>
  );
};

export const TrackedShadowButton = withClickTracking(ShadowButton);
